// Validação de CNPJ compatível com o formato tradicional (14 dígitos numéricos) e com o
// CNPJ Alfanumérico da Receita Federal (12 primeiras posições alfanuméricas A-Z/0-9 + 2
// dígitos verificadores numéricos). Substitui `cnpj` da lib `cpf-cnpj-validator` (só numérica).
// Algoritmo espelha o backend: MonitorContabil.Infra.Data.Shared/Utils/StringUtils.cs
// (`IsCnpjValido` / `CalcularDigitosVerificadoresCnpj`) — Nota Técnica COCAD/SUARA/RFB nº 49/2024.

const BLACKLIST = [
  '00000000000000',
  '11111111111111',
  '22222222222222',
  '33333333333333',
  '44444444444444',
  '55555555555555',
  '66666666666666',
  '77777777777777',
  '88888888888888',
  '99999999999999',
]

const STRICT_STRIP_REGEX = /[-\\/.]/g
const LOOSE_STRIP_REGEX = /[^A-Za-z0-9]/g

const PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const PESOS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

// dígitos '0'-'9' mantêm 0-9, letras 'A'-'Z' valem 17-42 (código ASCII - 48)
const valorCaractere = caractere => caractere.toUpperCase().charCodeAt(0) - 48

const calcularDigitoVerificador = (valor, pesos) => {
  const soma = valor
    .split('')
    .reduce((acumulado, caractere, indice) => acumulado + valorCaractere(caractere) * pesos[indice], 0)
  const resto = soma % 11
  return resto < 2 ? 0 : 11 - resto
}

const strip = (numero, strict) => {
  const regex = strict ? STRICT_STRIP_REGEX : LOOSE_STRIP_REGEX
  return (numero || '').replace(regex, '')
}

const format = numero => strip(numero)
  .replace(/^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})(\d{2})$/, '$1.$2.$3/$4-$5')

const isFormatoValido = stripped => {
  if (stripped.length !== 14) return false

  for (let i = 0; i < 12; i += 1) {
    if (!/[A-Za-z0-9]/.test(stripped[i])) return false
  }

  return /\d/.test(stripped[12]) && /\d/.test(stripped[13])
}

const isValid = (numero, strict) => {
  const stripped = strip(numero, strict).toUpperCase()

  if (!stripped) return false
  if (!isFormatoValido(stripped)) return false
  if (BLACKLIST.includes(stripped)) return false

  const base = stripped.substr(0, 12)
  const dv1 = calcularDigitoVerificador(base, PESOS_DV1)
  const dv2 = calcularDigitoVerificador(base + dv1, PESOS_DV2)

  return `${dv1}${dv2}` === stripped.substr(-2)
}

export const cnpj = {
  strip,
  format,
  isValid,
}

export default cnpj
